import { Popover } from "antd";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { BellOutlined } from "@ant-design/icons";
import Style from "./style";
import PopoverContent from "./PopoverContent";
import { UserService } from "../../../../services";

export default function NotificationTour({ module = 'pme', total = 0 }) {
  const goTo = useNavigate();
  const [shown, setShown] = useState(true);
  const [visible, setVisible] = useState(true);

  const onApprove = async () => {
    goTo(module === 'tif' ? `/app/tif/programs?status=pending` :`/app/${module}/projects/invitations`);
    setVisible(false);

    try {
      await UserService.updateUserPreference({
        key: "notification_steper",
        value: "done"
      });
    } catch (err) {
      console.log(err);
    }

    setTimeout(() => {
      setShown(false);
    }, 400);
  };

  const onClose = async () => {
    setVisible(false);

    try {
      await UserService.updateUserPreference({
        key: "notification_steper",
        value: "skipped"
      });
    } catch (err) {
      console.log(err);
    }

    setTimeout(() => {
      setShown(false);
    }, 400);
  };

  if (shown) {
    return (
      <Style className={visible ? 'visible' : 'not-visible'}>
        <Popover
          open={visible}
          placement="bottom"
          content={(<PopoverContent onApprove={onApprove} onClose={onClose} />)}
        >
          <div className="noti-icon-cont">
            <div className="notification-icon">
              <BellOutlined />
              {total ? (
                <div className="noti-more-cont">
                  {total}
                </div>
              ) : null}
            </div>
          </div>
        </Popover>
      </Style>
    );
  }

  return null;
}
